<template>
    <div class="container">
        <vue-headful
                title="Home - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">Top Users</h3>
                            </div>
                            <div class="col text-right">
                                <router-link class="btn btn-sm btn-primary" :to="{name: 'website-users'}">See all</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col">User ID</th>
                                <th scope="col">Username</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">User Type</th>
                                <th scope="col">Profile Views</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="user in orderedUsers" :key="user.id">
                                <th scope="row">
                                    {{user.id}}
                                </th>
                                <td scope="row">
                                    <strong>{{user.username}}</strong>
                                </td>
                                <td>
                                    <span class="" v-for="profile in user.profile" :key="profile.id">
                                        {{profile.first_name}} {{profile.last_name}}
                                    </span>

                                </td>
                                <td>
                                    {{user.email}}
                                </td>
                                <td>
                                    <span v-if="user.user_type == 1" class="text-green">Student</span>
                                    <span v-else class="text-info">Startup</span>
                                </td>
                                <td>
                                    {{user.profile_views}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">Top Ideas</h3>
                            </div>
                            <div class="col text-right">
                                <router-link class="btn btn-sm btn-primary" :to="{name: 'website-ideas'}">See all</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col">Idea ID</th>
                                <th scope="col">Idea Title</th>
                                <th scope="col">Idea Author</th>
                                <th scope="col">Idea Views</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="idea in orderedIdeas" :key="idea.id">
                                <th scope="row">
                                    {{idea.id}}
                                </th>
                                <td scope="row">
                                    <strong>{{idea.idea_title}}</strong>
                                </td>
                                <td>
                                    {{idea.user.username}}
                                </td>
                                <td>
                                    {{idea.idea_views}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import _ from "lodash";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      topUsers: {},
      topIdeas: {}
    };
  },
  mounted() {
    axios({
      method: "get",
      url:
        "admin/dashboard?access_token=" + localStorage.getItem("access_token"),
      body: {},
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(
        result => {
          this.topUsers = result.data.top_users;
          this.topIdeas = result.data.top_ideas;
        },
        error => {
          console.log(error.response);
        }
      )
      .catch(e => {
        console.log(e);
      });
  },
  computed: {
    orderedUsers: function() {
      return _.orderBy(this.topUsers, "profile_views", "desc");
    },
    orderedIdeas: function() {
      return _.orderBy(this.topIdeas, "idea_views", "desc");
    }
  },
  components: {
    "vue-headful": vueHeadful
  }
};
</script>
<style>
</style>
